import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const summaryRowStyle = {
    font: { bold: true, sz: 11, color: { rgb: '181D27' } },
    fill: { fgColor: { rgb: 'F3F4F6' } },
    alignment: { horizontal: 'right', vertical: 'center' },
};
const formatCurrency = (value) => {
    const num = Number(value) || 0;
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
const formatGrowth = (value) => {
    if (value === null || value === undefined)
        return '0%';
    return `${(Number(value) || 0).toFixed(2)}%`;
};
/**
 * Export the Paid Media Monthly Projection table to XLSX.
 * Columns mirror the on-screen table: #, Store Name, {Base} REV, YOY Growth Rate, PROJ {Target} REV.
 */
export function exportMonthlyProjection(rows, totalSummary, meta) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    try {
        const baseLabel = meta?.base_year_month_label || 'BASE';
        const targetLabel = meta?.year_month_label || 'PROJ';
        const headers = ['Client Name', `${baseLabel} REV`, 'YOY Growth Rate', `PROJ ${targetLabel} REV`];
        const data = rows.map((row) => [
            row.client_name || '',
            formatCurrency(row.base_revenue),
            formatGrowth(row.yoy_growth_rate),
            formatCurrency(row.projected_revenue),
        ]);
        const summaryRow = [
            'Total Summary',
            formatCurrency(totalSummary?.total_base_revenue),
            '',
            formatCurrency(totalSummary?.total_projected_revenue),
        ];
        const numCols = headers.length;
        const titleText = `Monthly Projection (Paid Media)${targetLabel ? ` - ${targetLabel}` : ''}`;
        const titleRow = [titleText, ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, headers, ...data, summaryRow];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        if (worksheet['A1'])
            worksheet['A1'].s = titleStyle;
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }, // Title
        ];
        // Header row (row index 2 after title + spacer).
        for (let c = 0; c < numCols; c++) {
            const headerCell = XLSX.utils.encode_cell({ r: 2, c });
            if (worksheet[headerCell])
                worksheet[headerCell].s = columnHeaderStyle;
        }
        // Summary row styling.
        const summaryRowIndex = 3 + rows.length;
        for (let c = 0; c < numCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: summaryRowIndex, c });
            if (worksheet[cellRef])
                worksheet[cellRef].s = summaryRowStyle;
        }
        worksheet['!cols'] = [{ wch: 28 }, { wch: 20 }, { wch: 18 }, { wch: 22 }];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Monthly Projection');
        const safeMonth = meta?.year_month?.replace('-', '_') || 'projection';
        XLSX.writeFile(workbook, `Monthly_Projection_${safeMonth}.xlsx`);
    }
    catch (error) {
        console.error('Export failed:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportMonthlyProjection;
